import React, { useEffect, createElement } from 'react';
import { Toaster } from 'sonner';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalTransition } from './components/EmotionalTransition';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { PackComposite } from './components/PackComposite';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TrustBar } from './components/TrustBar';
import { FAQSection } from './components/FAQSection';
import { PurchasePopup } from './components/PurchasePopup';
import { CountdownTimer } from './components/CountdownTimer';
import { Footer } from './components/Footer';
import { CHECKOUT_URL, META_PIXEL_ID } from './utils/constants';
export function App() {
  useEffect(() => {
    try {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      w.fbq('init', META_PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch (e) {
      // Meta Pixel init failed silently
    }
  }, []);
  return <div className="min-h-screen bg-gray-50 font-sans" data-id="element-0">
      <Toaster data-id="element-1" />
      <PurchasePopup data-id="element-2" />
      <StickyBar data-id="element-3" />

      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <SocialProof data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <EmotionalTransition data-id="element-8" />
        <ProductPresentation data-id="element-9" />
        <WhatIsIncluded data-id="element-10" />
        <PackComposite data-id="element-11" />
        <BonusSection data-id="element-12" />
        <UrgencySection data-id="element-13" />
        <OfferSection data-id="element-14" />
        <TestimonialsSection data-id="element-15" />
        <GuaranteeSection data-id="element-16" />
        <TrustBar data-id="element-17" />
        <FAQSection data-id="element-18" />

        {/* Sezione CTA Finale */}
        <section className="py-16 px-4 bg-blue-900 text-center" data-id="element-19">
          <div className="max-w-3xl mx-auto" data-id="element-20">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-21">
              Non perdere questa opportunit&agrave;. L&apos;offerta scade a
              breve!
            </h2>
            <div className="flex justify-center mb-8" data-id="element-22">
              <CountdownTimer light data-id="element-23" />
            </div>
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto bg-green-600 hover:bg-green-500 text-white font-bold text-xl py-5 px-12 rounded-full shadow-[0_8px_30px_rgb(22,163,74,0.3)] transform hover:-translate-y-1 transition-all duration-300 animate-pulse-fast" data-id="element-24">
              ACQUISTA ORA
            </a>
          </div>
        </section>
      </main>

      <Footer data-id="element-25" />
    </div>;
}